import { initAnonymousTracking } from "@/analytics/init";
import { autofocus } from "@/directives/autofocus";
import { focusTrap } from "@/directives/focus-trap";
import { keyboardNavigation } from "@/directives/keyboardNavigation";
import { gtmId, isCloud } from "@/environment";
import { handleError } from "@/errorHandler";

import AlmHandler from "./handlers/almHandler";

let gtmInitialized = false;

export function initializeGTM() {
  if (gtmInitialized) return;
  if (!isCloud || !gtmId) return;
  gtmInitialized = true;

  // Google Tag Manager - exact snippet from Google
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f);
    } else {
      d.head.appendChild(j);
    }
  })(window, document, "script", "dataLayer", gtmId);

  // Google Tag Manager (noscript) fallback
  if (document.body) {
    var noscript = document.createElement("noscript");
    var iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=" + gtmId;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}

export function initializeGlobalVue(app) {
  app.config.errorHandler = handleError;
  app.config.warnHandler = handleError;

  initAnonymousTracking();

  // Plugin registration
  app.use(AlmHandler);
}

export function registerDirectives(app) {
  app.directive("autofocus", autofocus());
  app.directive("focus-trap", focusTrap());
  app.directive("keyboard-nav", keyboardNavigation());
}
